export const primitiveTypeUniq = <T>(values: T[]) => [...new Set(values)];
